import { render, staticRenderFns } from "./Receipt-transfer-modal.vue?vue&type=template&id=0f68bb6d&scoped=true"
import script from "./Receipt-transfer-modal.vue?vue&type=script&lang=js"
export * from "./Receipt-transfer-modal.vue?vue&type=script&lang=js"
import style0 from "./Receipt-transfer-modal.vue?vue&type=style&index=0&id=0f68bb6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68bb6d",
  null
  
)

export default component.exports